import React, { useEffect, useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { IOrderDetails } from '../../../models/order';
import { ISession } from '../../../models/pro-sites';
import { loadSession } from '../../../store/session/session-actions';
import { IStarkeyContact } from '../../../models/constants';
import * as CONTACTS from './contacts';

interface IContactsHomeProps {
    order: IOrderDetails;
    session: ISession | null;
    loadSession: () => Promise<void>;
}
export const ContactsHome = ({
    order,
    session,
    loadSession,
}: IContactsHomeProps) => {
    const intl = useIntl();
    const contactsList = CONTACTS.getContacts(session!.country);
    return (
        <>
            <div className="wrapper sha">
                <div
                    className="row"
                    style={{
                        marginTop: '0px',
                        marginBottom: '0px',
                        marginLeft: '-15px',
                        marginRight: '-15px',
                    }}
                >
                    {contactsList &&
                        contactsList.map((item: IStarkeyContact) => {
                            return (
                                <div className="col-sm-6">
                                    <div
                                        className="highlight contact-block"
                                        style={{ marginLeft: '20px' }}
                                    >
                                        {item.title && (
                                            <h4 style={{ marginLeft: '20px' }}>
                                                {intl.formatMessage({
                                                    id: item.title,
                                                    defaultMessage: item.title,
                                                })}
                                            </h4>
                                        )}
                                        {item.name && (
                                            <h5 style={{ marginLeft: '20px' }}>
                                                {item.name}
                                            </h5>
                                        )}
                                        <table style={{ marginLeft: '15px' }}>
                                            <tbody>
                                                {item.telephone && (
                                                    <tr>
                                                        <th>
                                                            <p>
                                                                <FormattedMessage
                                                                    id="Phone"
                                                                    defaultMessage="Phone"
                                                                />
                                                                :
                                                            </p>
                                                        </th>
                                                        <td>
                                                            <p>
                                                                {item.telephone}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                )}
                                                {item.email && (
                                                    <tr
                                                        style={{
                                                            margin: '0px',
                                                        }}
                                                    >
                                                        <th>
                                                            <p>
                                                                <FormattedMessage
                                                                    id="Email"
                                                                    defaultMessage="Email"
                                                                />
                                                                :
                                                            </p>
                                                        </th>
                                                        <td>
                                                            <p>{item.email}</p>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
    };
};

const mapDispatchToProps = {
    loadSession,
};
const contactsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactsHome);
export default contactsContainer;
